import { PhoneCall, MessageCircle, Mail, Bot, Clock, ShieldCheck, Factory, MapPin } from "lucide-react";
import { AZIENDA } from "@/lib/config";

const HERO_IMG = "https://images.unsplash.com/photo-1676210133055-eab6ef033ce3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

const Badge = ({ icon: Icon, children }) => (
  <span className="inline-flex shrink-0 whitespace-nowrap items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-sky-50 text-sky-800 border border-sky-200">
    <Icon className="w-3.5 h-3.5" /> {children}
  </span>
);

export const Hero = ({ onOpenChat }) => (
  <section className="relative water-bg" data-testid="hero-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-8 pb-12 sm:py-20 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
      <div className="lg:col-span-7">
        <div className="flex gap-2 mb-6 fade-up overflow-x-auto no-scrollbar -mx-4 px-4 sm:mx-0 sm:px-0 sm:flex-wrap">
          <Badge icon={Clock}>Servizio H24 · 7 giorni su 7</Badge>
          <Badge icon={ShieldCheck}>30 anni di esperienza</Badge>
          <Badge icon={Factory}>Civile · Industriale · Speciale</Badge>
          <Badge icon={MapPin}>Provincia di Rimini</Badge>
        </div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] fade-up delay-1">
          Problema idraulico?<br />
          <span className="text-sky-600">Ti aiutiamo subito,</span> giorno e notte.
        </h1>
        <p className="mt-6 text-base sm:text-lg text-slate-600 max-w-xl fade-up delay-2">
          Pronto intervento H24 in tutta la provincia di Rimini su impianti idraulici civili, industriali e speciali. Scegli come contattarci:
          chiamata, WhatsApp o email. Oppure descrivi il problema al nostro assistente virtuale.
        </p>
        <div className="mt-8 grid sm:grid-cols-2 gap-3 max-w-xl fade-up delay-3">
          <a href={AZIENDA.telefonoLink} className="pulse-ring flex items-center gap-3 rounded-2xl bg-orange-600 text-white p-4 hover:bg-orange-700 transition-colors" data-testid="hero-call-btn">
            <PhoneCall className="w-6 h-6" />
            <span><span className="block font-extrabold text-lg leading-tight">Chiama ora</span><span className="text-sm opacity-90">{AZIENDA.telefono}</span></span>
          </a>
          <a href={AZIENDA.whatsappLink} target="_blank" rel="noreferrer" className="flex items-center gap-3 rounded-2xl bg-green-600 text-white p-4 hover:bg-green-700 transition-colors" data-testid="hero-whatsapp-btn">
            <MessageCircle className="w-6 h-6" />
            <span><span className="block font-extrabold text-lg leading-tight">WhatsApp</span><span className="text-sm opacity-90">Invia foto del guasto</span></span>
          </a>
          <a href={AZIENDA.emailLink} className="flex items-center gap-3 rounded-2xl bg-white border border-slate-200 p-4 hover:border-sky-400 transition-colors" data-testid="hero-email-btn">
            <Mail className="w-6 h-6 text-sky-600" />
            <span><span className="block font-extrabold text-lg leading-tight">Email</span><span className="text-sm text-slate-500">{AZIENDA.email}</span></span>
          </a>
          <button onClick={onOpenChat} className="flex items-center gap-3 rounded-2xl bg-slate-900 text-white p-4 text-left hover:bg-slate-800 transition-colors" data-testid="hero-open-chat-btn">
            <Bot className="w-6 h-6 text-sky-300" />
            <span><span className="block font-extrabold text-lg leading-tight">Assistente virtuale</span><span className="text-sm opacity-80">Descrivi il problema</span></span>
          </button>
        </div>
      </div>
      <div className="lg:col-span-5 relative">
        <div className="rounded-3xl overflow-hidden shadow-xl aspect-[4/3] sm:aspect-[4/5] max-h-[540px] w-full">
          <img src={HERO_IMG} alt="Idraulico al lavoro su un impianto" className="w-full h-full object-cover" />
        </div>
        <div className="absolute -bottom-5 left-4 right-4 sm:left-auto sm:-left-6 sm:right-auto bg-white rounded-2xl shadow-lg border border-slate-200 p-4 flex items-center gap-3">
          <span className="text-3xl font-extrabold text-sky-600">30</span>
          <span className="text-sm font-semibold leading-tight">anni di esperienza<br /><span className="text-slate-500 font-medium">nel settore idraulico</span></span>
        </div>
      </div>
    </div>
  </section>
);
